import { MessageCircle, Mail, LifeBuoy } from "lucide-react";
import { useSupportContacts } from "@/hooks/useCatalog";

export default function VendorSupport() {
  const { data: contacts } = useSupportContacts();
  const wa = `https://wa.me/${(contacts?.whatsapp || "").replace(/[^0-9]/g, "")}`;
  return (
    <div className="space-y-6" data-testid="vendor-support">
      <div>
        <h1 className="font-display text-2xl font-extrabold text-ink">Support revendeur</h1>
        <p className="mt-1 text-sm text-slate-500">Notre équipe vous accompagne {contacts?.hours || "7j/7"}.</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <a href={wa} target="_blank" rel="noreferrer" data-testid="vsupport-whatsapp" className="flex items-center gap-4 rounded-2xl border border-line bg-white p-5 hover:border-brand">
          <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600"><MessageCircle className="h-6 w-6" /></span>
          <div><p className="font-display font-bold text-ink">WhatsApp</p><p className="text-sm text-slate-500">{contacts?.whatsapp || "+2250140456948"}</p></div>
        </a>
        <a href={`mailto:${contacts?.email || "Cismo267@gmail.com"}`} data-testid="vsupport-email" className="flex items-center gap-4 rounded-2xl border border-line bg-white p-5 hover:border-brand">
          <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-light text-brand"><Mail className="h-6 w-6" /></span>
          <div><p className="font-display font-bold text-ink">Email</p><p className="text-sm text-slate-500">{contacts?.email || "Cismo267@gmail.com"}</p></div>
        </a>
      </div>
      <div className="flex items-start gap-3 rounded-2xl border border-line bg-brand-soft p-5">
        <LifeBuoy className="mt-0.5 h-5 w-5 shrink-0 text-brand" />
        <p className="text-sm text-slate-600">Pour toute question sur votre abonnement, vos paiements ou la gestion de votre boutique, contactez directement l'administrateur via WhatsApp ou email. Nous répondons rapidement.</p>
      </div>
    </div>
  );
}
